import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiHelperFunction from "../../api";
import { initialStateProps } from "./interface";

// ✅ Add Service  Thunk
export const addService = createAsyncThunk(
  "admin/create-service",
  async (payload: any, { dispatch, rejectWithValue }) => {
    try {
      console.log("1. Starting addService thunk with payload:", payload);
      const token = localStorage.getItem("user_token");

      // Format price and recurring_every to numbers
      // const formattedPayload = {
      //   ...payload,
      //   price: typeof payload.price === 'string' ? parseFloat(payload.price) : payload.price,
      //   recurring_every: typeof payload.recurring_every === 'string' ? Number(payload.recurring_every) : payload.recurring_every,
      //   recurring_period: typeof payload.recurring_period === 'string' ? Number(payload.recurring_period) : payload.recurring_period
      // };
      const formattedPayload = {
        ...payload,
        recuring: typeof payload.recuring === 'string' ? Number(payload.recuring) : payload.recuring,
        recurring_every: payload.recurring_every, // already a string, no need to parse
        price:  payload.price,
      };


      console.log("2. Formatted payload:", formattedPayload);

      const response = await ApiHelperFunction({
        url: "admin/create-service/",
        method: "post",
        data: formattedPayload,
        dispatch,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `${token}` : "",
        },
      });

      console.log("3. Raw API Response in addService:", response);
      
      if (!response?.data) {
        console.error("4. No response received from API");
        return rejectWithValue("No response received");
      }

      return response.data;

    } catch (error) {
      console.error("5. Error in addService thunk:", error);
      return rejectWithValue(error);
    }
  }
);

// ✅ Update Service Thunk
export const updateService = createAsyncThunk(
  "admin/update-service",
  async (
    { id, ...payload }: { id: number; [key: string]: any },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("user_token");
      
      // Add service_id to payload if id exists and format numbers
      // const updatedPayload = id
      //   ? {
      //       ...payload,
      //       service_id: id,
      //       recuring: payload.recuring, // Map recurring_period to recuring
      //       price: typeof payload.price === 'number' ? parseFloat(payload.price) : payload.price,
      //       recurring_every: payload.recurring_every,
      //     }
      //   : {
      //       ...payload,
      //       recuring: payload.recuring, // Map recurring_period to recuring
      //       price: typeof payload.price === 'number' ? parseFloat(payload.price) : payload.price,
      //       recurring_every: payload.recurring_every,
      //     };
      const updatedPayload = {
        ...payload,
        service_id: id,
        recuring: typeof payload.recuring === 'string' ? Number(payload.recuring) : payload.recuring,
        recurring_every: payload.recurring_every,
        price:   payload.price,
      };

      console.log("Update Service Payload:", updatedPayload);

      const response = await ApiHelperFunction({
        url: `admin/update-service/`,
        method: "put",
        data: updatedPayload,
        dispatch,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `${token}` : "",
        },
      });

      console.log("Raw API Response in updateService:", response);
      
      if (!response?.data) {
        return rejectWithValue("No response received");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// ✅ Delete Service Thunk (Dynamic ID)
export const deleteService = createAsyncThunk(
  "admin/delete-service",
  async (id: number, { dispatch }) => {
    const token = localStorage.getItem("user_token");

    const response = await ApiHelperFunction({
      url: `admin/delete-service/?service_id=${id}`,
      method: "delete",
      dispatch,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `${token}` : "",
      },
    });

    return response?.data;
  }
);

// ✅ Get Service List Thunk
export const getServiceList = createAsyncThunk(
  "admin/get-services-list",
  async (
    {
      offset = 0,
      limit = 10,
      search = "",
    }: { offset?: number; limit?: number; role_id?: number; search: "" },
    { dispatch }
  ) => {
    try {
      console.log("1. Starting getServiceList with params:", { offset, limit, search });
      const token = localStorage.getItem("user_token");

      const queryParams = new URLSearchParams({
        offset: offset.toString(),
        limit: limit.toString(),
      });
      if (search) {
        queryParams.append("search", search);
      }

      const response = await ApiHelperFunction({
        url: `admin/get-services-list/?${queryParams}`,
        method: "get",
        dispatch,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `${token}` : "",
        },
      });

      console.log("2. Raw API Response:", response);
      console.log("3. Response Data:", response?.data);
      console.log("4. Response Data Type:", typeof response?.data);
      console.log("5. Response Data Structure:", {
        hasData: !!response?.data?.data,
        dataLength: response?.data?.data?.length,
        firstItem: response?.data?.data?.[0]
      });

      return {
        data: response?.data?.data || [],
        total_records: response?.data?.total_records || 0,
      };
    } catch (error) {
      console.error("Error in getServiceList:", error);
      throw error;
    }
  }
);

// ✅ Get Single Service Thunk
export const getSingleService = createAsyncThunk(
  "admin/get-service",
  async (id: number, { dispatch }) => {
    const token = localStorage.getItem("user_token");

    const response = await ApiHelperFunction({
      url: `admin/get-service/?service_id=${id}`,
      method: "get",
      dispatch,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `${token}` : "",
      },
    });

    return response?.data?.data || {};
  }
);



// ✅ Initial State
export const initialState: initialStateProps = {
  status: "idle",
  error: "",
  token: "",
  data: [],
  total_records: 0,
  records_limit: 10,
  serviceDetail: [],
  detailLoading: "idle",
  serviceListStatus: "idle",
};
export const serviceSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    resetAll: (state) => {
      state.error = "";
      state.data = [];
      state.total_records = 0;
      state.records_limit = 10;
      state.serviceListStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ Add service
      .addCase(addService.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addService.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.payload?.data) {
          state.data = Array.isArray(state.data) ? [...state.data, action.payload.data] : [action.payload.data];
        }
      })
      .addCase(addService.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // ✅ Update service
      .addCase(updateService.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateService.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.payload?.data) {
          const updatedService = action.payload.data;
          state.data = Array.isArray(state.data) 
            ? state.data.map((service: any) => 
                service.id === updatedService.id ? updatedService : service
              )
            : [updatedService];
        }
      })
      .addCase(updateService.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // ✅ Delete service
      .addCase(deleteService.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.status = "succeeded";
        const deletedId = action.meta.arg;
        state.data = Array.isArray(state.data) 
          ? state.data.filter((service: any) => service.id !== deletedId)
          : [];
      })
      .addCase(deleteService.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // ✅ Get Service List
      .addCase(getServiceList.pending, (state) => {
        console.log("1. Service List Pending");
        state.serviceListStatus = "loading";
      })
      .addCase(getServiceList.fulfilled, (state, action) => {
        console.log("2. Service List Fulfilled:", action.payload);
        state.serviceListStatus = "succeeded";
        state.data = Array.isArray(action.payload.data) ? action.payload.data : [];
        state.total_records = action.payload.total_records || 0;
        console.log("3. Updated State:", { 
          data: state.data, 
          total_records: state.total_records,
          status: state.serviceListStatus,
          dataType: typeof state.data,
          isArray: Array.isArray(state.data),
          dataLength: state.data.length,
          firstItem: state.data[0]
        });
      })
      .addCase(getServiceList.rejected, (state, action) => {
        console.log("4. Service List Rejected:", action.error);
        state.serviceListStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(getSingleService.pending, (state) => {
        state.detailLoading = "loading";
      })
      .addCase(getSingleService.fulfilled, (state, action) => {
        state.detailLoading = "succeeded";
        state.serviceDetail = action.payload;
        state.total_records = action.payload.total_records;
      })
      .addCase(getSingleService.rejected, (state, action) => {
        state.detailLoading = "failed";
        state.error = action.error.message;
      });
  },
});